var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ApiClient } from '../../api/apiClient';
import { useForm } from '../../context/FormContext';
import { createSetExclusionStatusAction } from '../../types/form/actions';
import { trackVehicleConditionValuation } from '../../utils/analytics';
export var VehicleCondition = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var onNext = _a.onNext, onBack = _a.onBack, formData = _a.formData, refreshData = _a.refreshData;
    var dispatch = useForm().dispatch;
    // Form field states
    var _m = useState(''), odometer = _m[0], setOdometer = _m[1];
    var _o = useState([]), questions = _o[0], setQuestions = _o[1];
    var _p = useState({}), questionAnswers = _p[0], setQuestionAnswers = _p[1];
    var _q = useState(false), isLoadingQuestions = _q[0], setIsLoadingQuestions = _q[1];
    var _r = useState(true), isLoadingSavedData = _r[0], setIsLoadingSavedData = _r[1];
    // Form submission state
    var _s = useState(false), isSubmitting = _s[0], setIsSubmitting = _s[1];
    var _t = useState(null), formError = _t[0], setFormError = _t[1];
    // Initialize data from props or fallback to window settings
    useEffect(function () {
        var _a;
        // Get data from props or fall back to window settings
        //const savedData = formData || window.tiofSettings?.savedData || {};
        var savedData = ((_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.savedData) || {};
        // Set odometer if available
        if (savedData.v_mileage) {
            setOdometer(savedData.v_mileage);
        }
        // Load saved answers if available
        if (savedData.v_condition_info) {
            try {
                var savedAnswers = JSON.parse(savedData.v_condition_info);
                if (Array.isArray(savedAnswers)) {
                    var answerMap_1 = {};
                    savedAnswers.forEach(function (answer) {
                        // Support both new format (qId/choiceId) and old format (QuestionId/Choices)
                        var qId = answer.qId || answer.QuestionId;
                        var choiceId = answer.choiceId || (answer.Choices ? answer.Choices[0] : null);
                        if (qId && choiceId) {
                            answerMap_1[String(qId)] = [String(choiceId)];
                        }
                    });
                    setQuestionAnswers(answerMap_1);
                }
            }
            catch (err) {
            }
        }
        setIsLoadingSavedData(false);
    }, [formData]); // Re-run when formData prop changes
    // Fetch vehicle condition questions on component mount
    useEffect(function () {
        var isMounted = true;
        var fetchConditionQuestions = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isMounted)
                            return [2 /*return*/];
                        setIsLoadingQuestions(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, ApiClient.fetchVehicleConditionQuestions()];
                    case 2:
                        response = _a.sent();
                        if (isMounted) {
                            if (response.success && Array.isArray(response.data)) {
                                setQuestions(response.data);
                            }
                            else {
                                setFormError(response.error || 'Failed to load vehicle condition questions. Please try again.');
                            }
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        if (isMounted) {
                            setFormError('Failed to load vehicle condition questions. Please try again.');
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (isMounted) {
                            setIsLoadingQuestions(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchConditionQuestions();
        // Cleanup function to handle component unmounting
        return function () {
            isMounted = false;
        };
    }, []); // Empty dependency array to run only once
    // Handle answer change
    var handleAnswerChange = function (questionId, selectedChoices) {
        setQuestionAnswers(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[questionId] = selectedChoices, _a)));
        });
    };
    // Handle form submission
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var unansweredQuestions, formattedAnswers, readableFormat, result, actualData, exclusionData, scriptEl, refreshedData, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    // Basic validation
                    if (!odometer) {
                        setFormError('Please enter an odometer reading');
                        return [2 /*return*/];
                    }
                    unansweredQuestions = questions.filter(function (question) {
                        return questionAnswers[String(question.Id)] === undefined ||
                            questionAnswers[String(question.Id)].length === 0;
                    });
                    if (unansweredQuestions.length > 0) {
                        setFormError("Please answer all questions (".concat(unansweredQuestions.length, " unanswered)"));
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    setFormError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 9, 10, 11]);
                    formattedAnswers = Object.keys(questionAnswers).map(function (key) { return ({
                        qId: key,
                        choiceId: questionAnswers[key][0]
                    }); });
                    readableFormat = Object.keys(questionAnswers).map(function (questionId) {
                        var question = questions.find(function (q) { return String(q.Id) === questionId; });
                        if (!question)
                            return null;
                        var choiceIds = questionAnswers[questionId];
                        if (!choiceIds || choiceIds.length === 0)
                            return null;
                        // Handle multiple choices by joining them with commas
                        var choiceTexts = choiceIds.map(function (choiceId) {
                            var choice = question.Choices.find(function (c) { return String(c.Id) === String(choiceId); });
                            return choice ? choice.Description : null;
                        }).filter(Boolean);
                        return choiceTexts.length > 0 ? "<p>".concat(question.Description, ": ").concat(choiceTexts.join(', '), "</p>") : null;
                    }).filter(Boolean).join('');
                    return [4 /*yield*/, ApiClient.submitVehicleCondition({
                            v_mileage: odometer,
                            condition_questions: formattedAnswers,
                            condition_questions_readable: readableFormat
                        })];
                case 2:
                    result = _a.sent();
                    if (!result.success) return [3 /*break*/, 7];
                    actualData = result.data && Array.isArray(result.data) ? result.data[0] : result.data;
                    exclusionData = {
                        isExcluded: (actualData === null || actualData === void 0 ? void 0 : actualData.is_excluded) || false,
                        exclusionReasons: (actualData === null || actualData === void 0 ? void 0 : actualData.exclusion_reasons) || []
                    };
                    dispatch(createSetExclusionStatusAction(exclusionData));
                    if (!result.js_update) return [3 /*break*/, 4];
                    scriptEl = document.createElement('div');
                    scriptEl.innerHTML = result.js_update;
                    document.body.appendChild(scriptEl);
                    // Give the script a moment to execute
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 50); })];
                case 3:
                    // Give the script a moment to execute
                    _a.sent();
                    // Clean up
                    document.body.removeChild(scriptEl);
                    _a.label = 4;
                case 4:
                    if (!refreshData) return [3 /*break*/, 6];
                    return [4 /*yield*/, refreshData()];
                case 5:
                    refreshedData = _a.sent();
                    _a.label = 6;
                case 6:
                    // Track vehicle condition and valuation submission (Step 3)
                    trackVehicleConditionValuation();
                    onNext();
                    return [3 /*break*/, 8];
                case 7:
                    // Handle error from server
                    setFormError(result.error || 'Failed to save vehicle condition. Please try again.');
                    _a.label = 8;
                case 8: return [3 /*break*/, 11];
                case 9:
                    err_1 = _a.sent();
                    setFormError('Failed to save vehicle condition. Please try again.');
                    return [3 /*break*/, 11];
                case 10:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: "vehicle-condition", children: [_jsx("h2", { className: "text-center extra-pad-bottom", children: "Your Car's Condition" }), _jsxs("form", { onSubmit: handleSubmit, className: "max-500", children: [_jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "odometer", children: ((_d = (_c = (_b = window.tiofSettings) === null || _b === void 0 ? void 0 : _b.i18n) === null || _c === void 0 ? void 0 : _c.vehicleCondition) === null || _d === void 0 ? void 0 : _d.odometer) || 'Odometer (eg. 50,000)' }), _jsx("input", { type: "number", id: "odometer", name: "odometer", value: odometer, onChange: function (e) {
                                    var value = e.target.value;
                                    // Check if the value is a valid number or empty (for cases where it's being cleared)
                                    if (/^\d*$/.test(value)) {
                                        setOdometer(value);
                                    }
                                }, required: true, disabled: isSubmitting })] }), isLoadingQuestions ? (_jsx("div", { className: "loading-questions", children: "Loading vehicle condition questions..." })) : (questions.map(function (question) {
                        var _a;
                        var questionId = question.Id;
                        var currentAnswer = (_a = questionAnswers[questionId]) === null || _a === void 0 ? void 0 : _a[0];
                        // Check if this question should use option buttons
                        if (question.FieldType === 'option-buttons') {
                            return (_jsxs("div", { className: "condition-question-container", children: [_jsx("div", { className: "form-group full-width", children: _jsx("label", { children: question.Description }) }), question.Choices.map(function (choice) { return (_jsx("div", { className: "form-group condition-options", children: _jsx("button", { type: "button", className: "option-button ".concat(currentAnswer === choice.Id ? 'selected' : ''), onClick: function () { return handleAnswerChange(questionId, [choice.Id]); }, disabled: isSubmitting, children: _jsx("span", { children: choice.Description }) }) }, choice.Id)); })] }, questionId));
                        }
                        // Default: render as dropdown
                        return (_jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "condition_question_".concat(questionId), children: question.Description }), _jsxs("select", { value: currentAnswer !== null && currentAnswer !== void 0 ? currentAnswer : '', onChange: function (e) {
                                        handleAnswerChange(questionId, [e.target.value]);
                                    }, required: true, disabled: isSubmitting, children: [_jsxs("option", { value: "", children: ["Select ", question.Description] }), question.Choices.map(function (choice) { return (_jsx("option", { value: choice.Id, children: choice.Description }, choice.Id)); })] })] }, questionId));
                    })), _jsx("div", { className: "form-group full-width", children: _jsx("p", { className: "label-info", children: ((_g = (_f = (_e = window.tiofSettings) === null || _e === void 0 ? void 0 : _e.i18n) === null || _f === void 0 ? void 0 : _f.vehicleCondition) === null || _g === void 0 ? void 0 : _g.carConditionInfo) || 'Please note your responses are used to calculate your offer. Any Differences found during inspection may result in a variation or withdrawal of the offer. See our Terms & Conditions.' }) }), _jsx("div", { className: "form-group half-width text-right pad-top-25", children: _jsx("button", { type: "button", className: "button secondary icon-left", onClick: onBack, disabled: isSubmitting, children: ((_j = (_h = window.tiofSettings) === null || _h === void 0 ? void 0 : _h.i18n) === null || _j === void 0 ? void 0 : _j.previous) || 'Back' }) }), _jsx("div", { className: "form-group half-width pad-top-25", children: _jsx("button", { type: "submit", className: "button icon-right", disabled: isSubmitting || isLoadingQuestions || questions.length === 0, children: isSubmitting
                                ? 'Saving...'
                                : (((_l = (_k = window.tiofSettings) === null || _k === void 0 ? void 0 : _k.i18n) === null || _l === void 0 ? void 0 : _l.next) || 'Next') }) }), formError && (_jsx("div", { className: "error-message", children: formError }))] })] }));
};
